
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/warranty",
      function () {
        return require("private-next-pages/support/warranty/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/warranty"])
      });
    }
  